import { starterFertilizer } from '@terraframing-suite/rx-config';
import { useState } from 'react';
import { InputsHeader } from '../InputsHeader';
import { Grid } from '../layout';
import { Radio } from '../form-controls';
import { useContext } from '../context';
import { ProductConfiguration } from './ProductConfiguration';

export function Products() {
  const { getParam, updateParam } = useContext();
  const [productToConfigure, setProductToConfigure] = useState();

  return (
    <>
      {configureProduct()}
      <InputsHeader
        title="Products"
        name="starterFertilizer.products"
        subtitle="Select Products and Enter Percentage"
        required
      />
      <Grid columns={2} columnSpacing={{ xs: 2, sm: 3 }} rowSpacing={2}>
        {starterFertilizer.products.map(buildProductSelector)}
      </Grid>
    </>
  );

  function buildProductSelector(product, i) {
    const name = `starterFertilizer.products.${i}`;
    const configured = getParam(name);
    const isSelected = configured?.percentage > 0;

    return (
      <Radio
        key={i}
        radio={false}
        label={configured?.name || product.name}
        subLabel={isSelected && `${configured.percentage}%`}
        checked={isSelected}
        onChange={toggle}
        onSubActionClick={isSelected ? configure : null}
        sx={{ height: 46 }}
      />
    );

    function configure() {
      setProductToConfigure({ ...(configured || product), formName: name });
    }

    function toggle() {
      return isSelected ? updateParam(name, null) : configure();
    }
  }

  function configureProduct() {
    return productToConfigure ? (
      <ProductConfiguration
        product={productToConfigure}
        onCancel={cancel}
        onSave={save}
      />
    ) : null;

    function cancel() {
      setProductToConfigure(null);
    }

    function save({ formName, ...product }) {
      updateParam(formName, product);
      setProductToConfigure(null);
    }
  }
}
